/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { ALL_COMPONENT_TYPES } from '../store/viewPresets/types';
import type { WorkspacePresetLabels } from '../store/workspace/types';

export type LabelKey =
  | 'purpose'
  | 'parameters'
  | 'phenomena'
  | 'dataType'
  | 'viewType'
  | 'dataSource';

export const LABELS_CONFIG_DEFAULT: WorkspacePresetLabels = {
  purpose: [
    'Aviation',
    'Monitor',
    'Public',
    'Maritime',
    'Warning',
    'Media',
    'Nowcasting (0–12h)',
  ],
  parameters: [
    'Pressure',
    'Temperature',
    'Wind',
    'Humidity',
    'Water vapour',
    'Visibility',
    'Geopotential',
    'Snow',
    'Cloud',
    'Waves',
    'Index',
    'Precipitation',
  ],
  phenomena: [
    'Turbulence',
    'MTW',
    'CAT',
    'Icing',
    'Freezing rain',
    'FlashFlood',
    'Wind gust',
    'Rain',
    'Snow',
    'Road ice',
    'Lightning strike',
    'Drifting snow',
    'Wave height + water level',
    'Forest fire',
    'Polar Low',
    'Heat wave',
    'Gale warning',
  ],
  viewType: [...ALL_COMPONENT_TYPES],
  dataType: ['observation', 'forecast', 'archive'],
  dataSource: [
    'Meps',
    'Arome Arctic',
    'Ecmwf',
    'Ensemble',
    'AIFS',
    'BRIS',
    'radar',
    'satellite',
    'synop',
  ],
};
